import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { X } from 'lucide-react';
export function WhySolutionsFail() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const failedSolutions = [{
    name: 'Las apps de meditación',
    reason: 'asumen que ya estás en calma suficiente para meditar. Pero cuando la ansiedad es real — cuando tu mente lleva horas en bucle — sentarte a "observar tus pensamientos" es como pedirle a alguien que se ahoga que disfrute del agua.'
  }, {
    name: 'Los suplementos y las infusiones',
    reason: 'son agradables, pero no reprograman un sistema nervioso desregulado. Son parches temporales.'
  }, {
    name: 'Los consejos de "piensa positivo" o "deja de preocuparte"',
    reason: 'ignoran algo fundamental: la ansiedad no vive en tu mente. Vive en tu cuerpo. Está en la tensión de tus hombros. En la respiración superficial que ni siquiera notas. En la energía de cortisol atrapada en tus músculos que nunca se descarga porque nunca huyes ni luchas, solo aguantas.'
  }];
  return <section ref={ref} className="w-full px-6 py-10" data-id="element-294">
      <div className="max-w-3xl mx-auto" data-id="element-295">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-296">
          <img src="https://cdn.magicpatterns.com/uploads/75mbkTwZm4KGug24Pk9iSu/3dff7e23-795c-4f47-b092-0f7ff52000b1.jpg" alt="Persona agotada rodeada de suplementos, apps y libros que no funcionaron" className="w-full max-w-2xl mx-auto rounded-xl mb-8" data-id="element-297" />

          <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-8" data-id="element-298">
            Por qué todo lo que has probado no funciona — y no es culpa tuya
          </h2>

          <p className="text-lg md:text-xl mb-12" data-id="element-299">
            El mercado del bienestar está lleno de soluciones que atacan los
            síntomas sin tocar la causa.
          </p>

          <div className="space-y-8 mb-12" data-id="element-300">
            {failedSolutions.map((solution, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            delay: index * 0.15,
            duration: 0.5
          }} className="flex gap-4" data-id="element-301">
                <div className="flex-shrink-0 mt-1" data-id="element-302">
                  <X className="w-6 h-6 text-red-400/60" strokeWidth={2} data-id="element-303" />
                </div>
                <div data-id="element-304">
                  <span className="font-semibold text-warm-cream" data-id="element-305">
                    {solution.name}
                  </span>
                  <span className="text-warm-cream/80" data-id="element-306"> {solution.reason}</span>
                </div>
              </motion.div>)}
          </div>

          <p className="text-xl md:text-2xl font-playfair font-semibold text-amber-gold" data-id="element-307">
            Nadie te ha dado un botiquín de primeros auxilios para la mente.
          </p>
          <p className="text-xl md:text-2xl font-playfair font-semibold text-amber-gold mt-2" data-id="element-308">
            Hasta ahora.
          </p>
        </motion.div>
      </div>
    </section>;
}